import { Injectable } from '@angular/core';
import { Store} from '@ngrx/store';

import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../reducers';
import { CategoryActions, SaveCategories, PriceLevelActions, CategoryFormActions } from '../actions';
import { MessageActions} from '../actions/message.actions';

import {CategoryApi,HttpClient,PriceApi} from '../services/webservice';
import {Category } from '../models';


@Injectable()
export class CategoryEffect {
	constructor(
		private updates$: Actions,
		private categoryApi: CategoryApi,
		private categoryActions: CategoryActions,
		private categoryFormActions: CategoryFormActions,
		private store: Store<AppState>
	) { }

	@Effect() loadCategories$ = this.updates$
		.ofType(CategoryActions.LOAD_COLLECTION)
		.map(toPayload)
		.switchMap(url => this.categoryApi.getCategories(url))
		.map(categories => this.categoryActions.loadCollectionSuccess(categories))

	@Effect() categoryDeleteSuccess$ = this.updates$
		.ofType(CategoryFormActions.FORCE_CATEGORY_DELETE_SUCCESS)
		.withLatestFrom(this.store)
		.map(([action, state]) => this.categoryActions.loadCollection(state.eventServerState.categories.collectionUrl));
}



// WEBPACK FOOTER //
// ./src/app/effects/category.effect.ts